document.addEventListener('DOMContentLoaded', function() {
  const ctaElements = document.querySelectorAll('.js-cta');
  
  ctaElements.forEach(function(element) {
    element.addEventListener('click', function() {
      const channel = this.getAttribute('data-cta-channel');
      const position = this.getAttribute('data-cta-position');
      const label = this.getAttribute('data-cta-label');
      
      // 通用 CTA 点击事件
      if (typeof gtag !== 'undefined') {
        gtag('event', 'cta_click', {
          'event_category': 'engagement',
          'event_label': label,
          'cta_channel': channel,
          'cta_position': position
        });
      }
      
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          'event': 'cta_click',
          'cta_channel': channel,
          'cta_position': position,
          'cta_label': label
        });
      }
      
      // WhatsApp 专属事件
      if (channel === 'whatsapp') {
        if (typeof gtag !== 'undefined') {
          gtag('event', 'whatsapp_click', {
            'event_category': 'whatsapp_engagement',
            'event_label': position,
            'value': 1
          });
        }
        
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            'event': 'whatsapp_click',
            'position': position
          });
        }
        
        console.log('WhatsApp specific event tracked');
      }
      
      console.log('CTA clicked:', { channel, position, label });
    });
  });
});
